module.exports = __webpack_public_path__ + "img/9788949123332.94bc22ee.jpg";